export const MIN_TRANSFER = 20;
export const MIN_TRANSFER_INTERNATIONAL = 5500;
export const LIMIT_TRANSFER_PF = 2250;
